import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-blog-links',
    templateUrl: './blog-links.component.html',
    styleUrls: [],
    standalone: false
})
export class BlogLinksComponent {
  @Input() columns = "3";
  @Input() cards = [];

  constructor() {}
  
  ngOnInit() { }
}
